/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Intro, Controls, ControlGroup } from "components/containers";
import { Description, Title } from "components/typography";
import { Section, Wrapper } from "../styles";
import { fetchSocialMediaAssets } from "redux/actions/mktassets";
import AffiliateData from "utils/user-data";
import { ExportButton } from "components/buttons";
import SocialMediaAssetsTable from "components/tables/social-media";
import MainSelect from "components/main-select";

const SocialMA = () => {
  const dispatch = useDispatch();
  const loggedInAff = new AffiliateData();

  const { campaigns } = useSelector((state) => state.aff_campaigns);

  const options =
    campaigns === null
      ? []
      : campaigns.map((el) => ({ label: el.name, value: el.id }));

  useEffect(() => {
    dispatch(
      fetchSocialMediaAssets(
        {
          domain: loggedInAff.get().data.affiliate.domain,
          affId: loggedInAff.get().data.affiliate.id,
        },
        {}
      )
    );
  }, []);

  return (
    <Section>
      <Intro>
        <Title>Social media assets</Title>
        <Description>
          These assets have been optimized to aid your social media marketing.
        </Description>
      </Intro>
      <Wrapper>
        <Controls
          style={{
            padding: "1em",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          }}
        >
          {/* <ExportButton caption="Export Report" /> */}
          <ControlGroup>
            <MainSelect label={null} options={options} />
          </ControlGroup>
        </Controls>
        <SocialMediaAssetsTable />
      </Wrapper>
    </Section>
  );
};

export default SocialMA;
